import React from 'react';
import {default as badge} from '../../../../images/eco-alliance-badge.svg';
import CommunityImg from '../../../Common/CommunityImg/CommunityImg';
import useBlogsEcoAlliance from '../../../hooks/useBlogsEcoAlliance';
import './EcoCommunity.scss';

const EcoCommunity = () => {

  const blogsList = useBlogsEcoAlliance();
  const {edges} = blogsList?.posts;
  const blogs = edges;

  const openBlog = (slug) => window.open(`https://www.noissue.co/blog/${slug}`, '_blank', 'noopener');

  return (
    <div className="noissue__eco-alliance__sustainability__container__tabs__eco-community">
      <div className="eco-community-content">
          The Eco-Alliance is a growing community of businesses, makers, and brands who choose to utilize sustainable packaging and are committed to being better together. For every order placed, we plant trees in areas in need of reforestation.
           Membership within the community acknowledges this commitment and can be shared with customers through our Eco-Alliance badge.
        <br /> <br />
          Check out what sustainability means to our members by getting to know their businesses and how they’ve incorporated the badge into their messaging. We’re proud that, together, we’re making a difference, one tree at a time.
      </div>
      <div className="eco-community-community-blocks-list">
        {
          blogs.map((item, idx) => {
            return  <div className="eco-community-community-blocks" key={idx} >
                <CommunityImg className="eco-community-community-blocks-badge" src={badge} alt="eco alliance badge" />
                <CommunityImg 
                  role="presentation" 
                  className="eco-community-community-blocks-image" 
                  onClick={()=>openBlog(item.node.slug)} 
                  src={item.node.feature_image} 
                  alt="community blog" 
                />
                <div className="eco-community-community-blocks-details">
                  {item.node.excerpt}
                </div>
                <div className="eco-community-community-blocks-read-more" role="presentation"  onClick={()=>openBlog(item.node.slug)}>Read More</div>
            </div>
          })
        }
        <div className="eco-community-community-blocks-empty"></div>
      </div>
    </div>
  )
}

export default EcoCommunity;